export function alphaSort(a, b) {
  const al = a.toLowerCase();
  const bl = b.toLowerCase();
  return al > bl ? 1 : al === bl ? 0 : -1;
}
